import { render, staticRenderFns } from "./CompletedCoursesByLearner.vue?vue&type=template&id=56285f6c&scoped=true"
import script from "./CompletedCoursesByLearner.vue?vue&type=script&lang=js"
export * from "./CompletedCoursesByLearner.vue?vue&type=script&lang=js"
import style0 from "./CompletedCoursesByLearner.vue?vue&type=style&index=0&id=56285f6c&prod&scoped=true&lang=scss"
import style1 from "./CompletedCoursesByLearner.vue?vue&type=style&index=1&id=56285f6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56285f6c",
  null
  
)

export default component.exports